import {
  INDIVIDUAL_SEPARATOR_IDENTIFIER,
  PAGE_SEPARATOR_IDENTIFIER
} from '@components/UI-Components/HierarchyWiseItems/constants'
import { ScrollPositionStore } from '@stores/ScrollPositionStore'
import inRange from 'lodash/inRange'

export class HierarchyScrollPositionStore extends ScrollPositionStore {
  scrollToNode = id => {
    if (!id) {
      return
    }
    const node = this.elementRefStore.ref?.nodes?.find?.(node => {
      if (id.includes(PAGE_SEPARATOR_IDENTIFIER)) {
        return node.id === id
      } else if (id.includes(INDIVIDUAL_SEPARATOR_IDENTIFIER)) {
        if (node.id.includes(INDIVIDUAL_SEPARATOR_IDENTIFIER)) {
          return node.id === id
        } else {
          const [, start, end] = node.id.split(PAGE_SEPARATOR_IDENTIFIER)
          return inRange(+id.split(INDIVIDUAL_SEPARATOR_IDENTIFIER)[1], +start, +end)
        }
      } else {
        return node.id === id
      }
    })
    if (node) {
      this.scrollTop = node.top - node.stickyTop
      this.updateScrollToNode(node)
    }
  }
}
